import React from 'react';
import FormItem from '../FormItem/FormItem';
import Price from './Price';
import { fieldNames } from '../../config/form';
import { checkPrice, transformPrice } from '../../model/form';

const getInitVal = (invoice) => ({
  price: invoice?.sum ? `${invoice.sum / 100}` : '',
  isNotFinal: !invoice?.isFinal,
});

const options = {
  validateTrigger: 'onSubmit',
  rules: [{ validator: checkPrice, transform: transformPrice }],
};

const PriceField = ({ getFieldDecorator, invoice }) => {
  return (
    <FormItem
      label="Сумма"
      required
    >
      {getFieldDecorator(fieldNames.priceData, {
        initialValue: getInitVal(invoice),
        ...options,
      })(<Price />)}
    </FormItem>
  );
};

export default PriceField;
